export const GIFT_CARD_CART = 'GIFT_CARD_CART';

export function setGiftCardCart(payload) {
  return {
    type: GIFT_CARD_CART,
    payload,
  };
}
